import moment from "moment";
import { formatPrice } from "../../../utils/formatPrice";
import type { ICellRendererParams } from "ag-grid-community";
import { FormSubmissionTable } from "../../common/formSubmissionTable";
import { convertToFormattedAmount } from "../../../utils/convertAmount";
import type { BuyerSavedListing } from "../../../interfaces/buyerProfileInterface";

interface ListingTableProps {
  listings: BuyerSavedListing[];
}

export const ListingTable = ({ listings }: ListingTableProps) => {
  function handleListingIdClick(listingId: string) {
    const boardId = listingId[3];
    const mlsNumber = listingId.slice(4);
    if (boardId === "2") {
      const url = `https://onlistings.trreb.ca/searchlistings#search//listing/TREB-${mlsNumber}`;
      window.open(url, "_blank");
    } else {
      const url = `https://www.google.com/search?q=${mlsNumber}`;
      window.open(url, "_blank");
    }
  }

  return (
    <FormSubmissionTable
      columnDefs={[
        {
          field: "listingId",
          headerName: "Listing ID",
          filter: "agTextColumnFilter",
          floatingFilter: true,
          cellRenderer: (params: ICellRendererParams<BuyerSavedListing>) => (
            <span
              style={{
                textDecoration: "underline",
                cursor: "pointer"
              }}
              onClick={() => handleListingIdClick(params.value)}
              onKeyDown={() => handleListingIdClick(params.value)}
            >
              {params.value}
            </span>
          )
        },
        {
          field: "address",
          headerName: "Address",
          filter: "agTextColumnFilter",
          floatingFilter: true
        },
        {
          field: "city",
          headerName: "City",
          filter: "agTextColumnFilter",
          floatingFilter: true
        },
        {
          field: "province",
          headerName: "Province",
          filter: "agTextColumnFilter",
          floatingFilter: true
        },
        {
          field: "postalCode",
          headerName: "Postal Code",
          filter: "agTextColumnFilter",
          floatingFilter: true
        },
        {
          field: "listPrice",
          headerName: "List Price",
          filter: "agTextColumnFilter",
          floatingFilter: true
        },
        {
          field: "bedrooms",
          headerName: "Bedrooms",
          filter: "agTextColumnFilter",
          floatingFilter: true
        },
        {
          field: "bathrooms",
          headerName: "Bathrooms",
          filter: "agTextColumnFilter",
          floatingFilter: true
        },
        {
          field: "squareFeet",
          headerName: "Square Feet",
          filter: "agTextColumnFilter",
          floatingFilter: true
        },
        {
          field: "downPaymentGiven",
          headerName: "Down Payment Given",
          filter: "agTextColumnFilter",
          floatingFilter: true
        },
        {
          field: "downPaymentNeeded",
          headerName: "Down Payment Needed",
          filter: "agTextColumnFilter",
          floatingFilter: true
        },
        {
          field: "listDate",
          headerName: "List Date",
          filter: "agTextColumnFilter",
          floatingFilter: true
        }
      ]}
      rowData={listings.map((property) => ({
        listingId: property.listingId,
        address: property.address.address1,
        city: property.address.city,
        province: property.address.state,
        postalCode: property.address.postalCode,
        listPrice: `$${formatPrice(
          convertToFormattedAmount(property.listPrice.amount)
        )}`,
        bedrooms: property.bedrooms,
        bathrooms: property.bathrooms,
        squareFeet: property.squareFeet || 0,
        downPaymentGiven: `$${formatPrice(
          convertToFormattedAmount(property.downPaymentGiven.amount)
        )}`,
        downPaymentNeeded: `$${formatPrice(
          convertToFormattedAmount(property.downPaymentNeeded.amount)
        )}`,
        listDate: moment(property.listDate).format("YYYY-MM-DD hh:mm a")
      }))}
      pageSize={10}
      height="500px"
    />
  );
};
